import dynamic from "next/dynamic"
import { Partner } from "common/types/graphql"
import { AccordionPartnersView } from "./AccordionPartners.view"
import { usePageProps } from "common/hooks/data/usePageProps"
import type { EditPageProps } from "pages/edit/index.page"

const PartnersEdit = dynamic<PartnersProps>(() =>
  import("./Partners.edit").then((mod) => mod.PartnersEdit),
)

export interface PartnersProps {
  partners?: Partner[]
  explainer?: string
  partnerLinkDescription?: string
}

export const Partners = (props: PartnersProps) => {
  const { editing } = usePageProps<EditPageProps>()
  const PartnersComponent = editing ? PartnersEdit : AccordionPartnersView

  return <PartnersComponent {...props} />
}
